import React from 'react';
import { Wordmark } from './Wordmark';
import { Monogram } from './Monogram';
export function VeraReserve() {
  return <section className="py-40 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto border-y border-brass" data-id="element-93" data-mp="3ksppg0ssis9x">
      {/* Flagship label and wordmark lockup */}
      <div className="flex flex-col items-center text-center mb-8" data-id="element-94" data-mp="3gpt2xz04qc0p">
        <div className="font-mono text-xs uppercase tracking-[0.4em] text-brass mb-10" data-id="element-95" data-mp="3bunm3ell3njh">
          The Flagship
        </div>

        <Wordmark size="xl" submark="Reserve" align="center" data-id="element-96" data-mp="cbmmju0yxx22" />

        <div className="mt-10 mb-6" data-id="element-97" data-mp="8dov0kjq6yvi">
          <Monogram className="text-sm" rule data-id="element-98" data-mp="8aj8nd2heb3h" />
        </div>
      </div>

      {/* Framing line — the retainer as a managed whole */}
      <p className="font-serif font-light text-ink/80 text-xl md:text-2xl text-center max-w-2xl mx-auto mb-24 leading-relaxed" data-id="element-99" data-mp="3ukdddrq51r6n">
        Your Chief Executive of Health. We handle the training, the meals, the
        travel, the recovery, and the coordination with your physicians and
        specialists. Everything moves in one direction without you having to
        think about it.
      </p>

      {/* The three pillars — Strategic Refinement treatment: large brass
              numeral, brass hairline rule, serif headline, then body */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 mb-32" data-id="element-100" data-mp="f467abmchr1j">
        <div data-id="element-101" data-mp="k27mumkkb889">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-102" data-mp="k1o5b6ytqlur">
            01
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-103" data-mp="a5bbm93a4800" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-104" data-mp="a7fqfm2purf2">
            Health Operations
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-105" data-mp="1e2o5tiridgb">
            Training, nutrition, and recovery, built as one system and
            coordinated alongside your physicians and specialists.
          </p>
        </div>

        <div data-id="element-106" data-mp="3nm29iyasq9hi">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-107" data-mp="34fcmnp19bh52">
            02
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-108" data-mp="2znuvfsp1cuxa" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-109" data-mp="2up9uts5vg98b">
            Travel &amp; Environment
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-110" data-mp="2povku4kpmp7n">
            Your hotels, gyms, meals, and jet lag are handled before you land
            in any city.
          </p>
        </div>

        <div data-id="element-111" data-mp="3dgauyjiqaatg">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-112" data-mp="3dfrjnlnl2koe">
            03
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-113" data-mp="38genubeqi39o" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-114" data-mp="221e0gu3rytep">
            Executive Integration
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-115" data-mp="ck0dfke1d36m">
            Your team is looped in from week one, so you can focus on building
            while we handle the details.
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-116" data-mp="mh4zlk7vsynf">
        <p className="font-serif font-light text-ink/80 text-xl md:text-2xl leading-relaxed mb-12" data-id="element-117" data-mp="r969izhkudaa">
          The roster is held at eight clients so the standard never slips, and
          three of those seats are open now.
        </p>
        <a href="https://form.jotform.com/262156242446051" target="_blank" rel="noopener noreferrer" className="cta-link" data-id="element-118" data-mp="108028ersejik">
          Begin the Application
          <span className="ml-2 font-serif text-lg leading-none" data-id="element-119" data-mp="1a6zcu2w44p87">→</span>
        </a>
      </div>
    </section>;
}